export default "__VITE_ASSET__L_1JmMXd__"